import Isotype from "./Isotype";
import Logotype from "./Logotype";

export default { Isotype, Logotype };
